import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card card-feat" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, " Önskar du ansöka om ett annat belopp fyller du i det här: ", -1)
const _hoisted_5 = { class: "row my-3" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nytt lånebelopp", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary mt-3"
}, " ÄNDRA ANSÖKAN ", -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "message-short" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Vi kommer hantera din ändring i den ordning den inkommit till oss under våra normala öppettider måndag-fredag. Vill du göra ytterligare ändringar kan du skicka ett ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("nytt meddelande")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" till oss. Vi kommer då se det nya meddelandet samtidigt som det automatiska meddelandet ovan. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.submitted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("form", {
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.changeRequestLoanAmount) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.changeRequestLoanAmount]
                    ]),
                    _hoisted_8
                  ])
                ])
              ], 32)
            ]))
          : _createCommentVNode("", true),
        (_ctx.submitted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_router_link, { to: "/message/add" }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _hoisted_13
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}